import React from 'react';
import { Row, Col, Card, Table, Spinner, Badge } from 'react-bootstrap';
import { InvitationStatusPieChart } from './charts/ResponseCharts';

const InvitationsTab = ({ invitationStats, loading, getInvitationResponses }) => {
    return (
        <>
            <Row className="mb-4">
                <Col md={6}>
                    <Card className="h-100">
                        <Card.Body>
                            <Card.Title>Invitation Statistics</Card.Title>
                            <Table striped bordered hover className="mt-3">
                                <tbody>
                                <tr>
                                    <th>Total Invitations Sent:</th>
                                    <td>{invitationStats.totalInvitations}</td>
                                </tr>
                                <tr>
                                    <th>Started Surveys:</th>
                                    <td>
                                        {invitationStats.startedCount}
                                        <span className="text-muted ms-2">
                                                ({(invitationStats.startRate).toFixed(1)}%)
                                            </span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>Completed Surveys:</th>
                                    <td>
                                        {invitationStats.completedCount}
                                        <span className="text-muted ms-2">
                                                ({(invitationStats.completionRate).toFixed(1)}%)
                                            </span>
                                    </td>
                                </tr>
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={6}>
                    <Card className="h-100">
                        <Card.Body>
                            <Card.Title>Invitation Status</Card.Title>
                            <InvitationStatusPieChart
                                completedCount={invitationStats.completedCount}
                                startedCount={invitationStats.startedCount}
                                totalInvitations={invitationStats.totalInvitations}
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Card className="mb-4">
                <Card.Body>
                    <Card.Title>Invitation Management</Card.Title>
                    <div className="alert alert-info">
                        <p>This survey has had <strong>{invitationStats.totalInvitations}</strong> invitations sent so far.</p>
                        <p>Email invitations allow you to track specific respondents through unique session identifiers.</p>
                    </div>
                </Card.Body>
            </Card>

            <Card className="mb-4">
                <Card.Body>
                    <Card.Title>Invitation Details</Card.Title>
                    {loading ? (
                        <div className="text-center my-4">
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>
                            <p className="mt-2">Loading invitation details...</p>
                        </div>
                    ) : getInvitationResponses().length > 0 ? (
                        <div className="table-responsive">
                            <Table striped bordered hover>
                                <thead>
                                <tr>
                                    <th>Email</th>
                                    <th>Sent Date</th>
                                    <th>Status</th>
                                    <th>Last Activity</th>
                                </tr>
                                </thead>
                                <tbody>
                                {getInvitationResponses().map((response, index) => (
                                    <tr key={index}>
                                        <td>{response.email}</td>
                                        <td>{response.invitationSentAt ? new Date(response.invitationSentAt).toLocaleString() : 'N/A'}</td>
                                        <td>
                                            {response.isSubmitted ? (
                                                <Badge bg="success">Completed</Badge>
                                            ) : response.answers && response.answers.length > 0 ? (
                                                <Badge bg="warning">Started</Badge>
                                            ) : (
                                                <Badge bg="secondary">Not Started</Badge>
                                            )}
                                        </td>
                                        <td>
                                            {response.lastActivityAt ?
                                                new Date(response.lastActivityAt).toLocaleString() :
                                                'No activity'}
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                        </div>
                    ) : (
                        <div className="alert alert-info">
                            No email invitations have been sent for this survey yet.
                        </div>
                    )}
                </Card.Body>
            </Card>
        </>
    );
};

export default InvitationsTab;